import { i18n } from '@/locales';
const lc = 'error_code.';
const result = {
    BAD_REQUEST: 400,
    /**
     * 라이더 관리 실패 사유
     */
    // 서버 에러문구 = 변경할 수 없는 가입상태입니다
    INVALID_STATUS_OF_WORKER_INSURANCE: i18n.t(`${lc}invalid_status_of_worker_insurance`),
    // 서버 에러문구 = worker 생성에 실패하였습니다
    FAIL_CREATE_WORKER: i18n.t(`${lc}fail_create_worker`),
    // 서버 에러문구 = 허브의 주문 정렬이 거리일 경우, 접수 목록 제한건수를 설정할 수 없습니다.
    IMPOSSIBLE_ACCEPTED_ORDER_VIEW_LIMIT_COUNT: i18n.t(`${lc}impossible_accepted_order_view_limit_count`),
    /**
     * 상점 관리 실패 사유
     */
    // 서버 에러문구 = 상점 관리비 설정에 대한 한달 누적 구간중 중복 되는 건이 있습니다.
    DUPLICATE_RANGE_STORE_MONTHLY_DELIVERY_COUNT: i18n.t(`${lc}duplicate_range_store_monthly_delivery_count`),
    // 서버 에러문구 = 중복된 상품금액 구간이 있습니다.
    DUPLICATED_GOODS_PRICE_SURCHARGE_INFO: i18n.t(`${lc}duplicated_goods_price_surcharge_info`),
    /**
     * 상점 관리 라이더 관리 공통
     */
    // 서버 에러문구 = 배달 대행료 설정 범위가 중복되었습니다.
    DUPLICATE_RANGE_DELIVERY_FEE_OPTION: i18n.t(`${lc}duplicate_range_delivery_fee_option`),
    /**
     * 구역설정 공통
     */
    // response.message = "요청한 {field} 값 및 타입을 확인해주세요.",
    SCHEMA_VALIDATE: i18n.t(`${lc}schema_validate`),
    // response.message = "요청한 coordinateList[0].latitude 값 및 타입을 확인해주세요."
    SCHEMA_VALIDATE_FORMAT: i18n.t(`${lc}schema_validate`),
};
export default result;
